<template>
  <el-dialog :close-on-click-modal="false" title="选择尺寸" :visible.sync="isShow" width="1250px" append-to-body>
    <el-form :inline="true" :model="searchComposeSizeVo" class="demo-form-inline">
      <el-form-item label="页面类型:">
        <el-select clearable v-model="searchComposeSizeVo.pageTypeCode" placeholder="">
          <el-option v-for="item in $store.state.pms.pageTypeList" :key='item.id' :label="item.typeName" :value="item.typeCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="尺寸名称:">
        <el-input v-model="searchComposeSizeVo.sizeName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addQueryInfo.pageNum = 1,searchSizeList()">查询</el-button>
      </el-form-item>
      <div>
        <el-table :data="sizeTableData" border style="width: 100%">
          <el-table-column prop="sizeName" label="尺寸名称"></el-table-column>
          <el-table-column label="页面类型">
            <template slot-scope="scope">
              {{
                $store.state.pms.pageType[scope.row.pageTypeCode]
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pageName" label="页面名称"></el-table-column>
          <el-table-column prop="address" label="宽高">
            <template slot-scope="scope">
              宽度：{{scope.row.sizeWidth}}<br>高度：{{scope.row.sizeHeight}}
            </template>
          </el-table-column>
          <el-table-column prop="bleed.bleedName" label="出血类型"></el-table-column>
          <el-table-column label="出血" width="210px">
            <template slot-scope="scope">
              上：{{scope.row.bleed.bleedTop}}mm 底部：{{scope.row.bleed.bleedBottom}}mm<br>
              内侧：{{scope.row.bleed.bleedIn}}mm 外侧：{{scope.row.bleed.bleedOut}}mm<br>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="折线">
            <template slot-scope="scope">
              <p v-for="(val,key) in scope.row.brokenLine" :key="key">{{key==='HORIZONTAL'?'水平折线':key==='VERTICAL'?'垂直折线':'未定义字段'}}：<span v-for="item in val"
                  :key="item">{{item}}mm</span></p>
            </template>
          </el-table-column>
          <el-table-column prop="barCodeId" label="码名称">
            <template slot-scope="scope">
              <p v-for="item in scope.row.barCodeList" :key="item.id">{{item.barName}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <span @click="choicedSize(scope)" class="color-blue">选择</span>
            </template>
          </el-table-column>
        </el-table>
        <v-pagination class="v-pagination" :queryInfo="addQueryInfo" @changePage="addChangePage"></v-pagination>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import VPagination from '@/components/Pagination/index'
import { groupListPageing, groupDelete, composeGroupUsable, groupCategoryList, composeGroupAdd, bleedDetail, pageTypeList, sizeListPaging, composeGroupDetail } from '@/api/pms'
export default {
  components: {
    VPagination
  },
  data () {
    return {
      isShow: false,
      searchComposeSizeVo: {
        pageName: '',
        pageTypeCode: '',
        sizeName: ''
      },
      addQueryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      sizeTableData: []
    }
  },
  methods: {
    show () {
      this.searchSizeList()
      this.isShow = true
    },
    choicedSize (scope) {
      this.$emit('selected', scope.row)
      this.isShow = false
    },
    searchSizeList () {
      sizeListPaging({ pageNum: this.addQueryInfo.pageNum, pageSize: this.addQueryInfo.pageSize, data: this.searchComposeSizeVo }).then(res => {
        if (res.data.success) {
          this.addQueryInfo.total = res.data.data.total
          let list = res.data.data.records
          list.forEach(item => {
            item.brokenLine = {}
            item.composeSizeBrokenLineXrefList.forEach(val => {
              if (!item.brokenLine[val.brokenLineDirection]) {
                item.brokenLine[val.brokenLineDirection] = []
              }
              item.brokenLine[val.brokenLineDirection].push(val.brokenLineValue)
            })
          })
          this.sizeTableData = list
        }
      })
    },
    addChangePage (val) {
      this.addQueryInfo = val
      this.searchSizeList()
    }
  }
}
</script>

<style>
</style>
